export default "__VITE_ASSET__DccRZIB4__"